import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { profile, valueProps } from "../../mock/mock";

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7 }}
          className="lg:col-span-5">
          <div className="section-label mb-6">About Me</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] tracking-[-0.02em]">
            Blending <span className="italic sage-text">creativity</span> with{" "}
            <span className="italic sage-text">strategy</span> for real results.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7 space-y-8">
          <p className="text-[18px] leading-[1.75] text-[var(--text-dim)] max-w-2xl">{profile.longBio}</p>
          <p className="text-[16px] leading-[1.8] text-[var(--text-dim)] max-w-2xl">
            I believe in continuous learning, experimenting with new trends, and pushing creative boundaries to deliver better results every time — whether it's a conversion-first website, a high-performance ad campaign, or a brand identity that actually sticks.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
            {valueProps.map((v) => (
              <div key={v} className="flex items-start gap-3 p-4 rounded-xl glass card-hover">
                <span className="mt-0.5 h-6 w-6 inline-flex items-center justify-center rounded-full bg-[var(--sage)]/15 border border-[var(--sage)]/30">
                  <Check size={14} className="text-[var(--sage)]" />
                </span>
                <span className="text-[15px] text-[var(--text)]">{v}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
